var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("header",function(){return [_c('layout-header')]}),_vm._v(" "),_c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"wrapper"},[_vm._t("default")],2)]),_vm._v(" "),_vm._t("footer",function(){return [_c('layout-footer')]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }